import hole1 from './assets/venues/minigolf-park/hole-1.webp'
import hole2 from './assets/venues/minigolf-park/hole-2.webp'
import hole3 from './assets/venues/minigolf-park/hole-3.webp'
import holeGlow1 from './assets/venues/glow-golf/hole-1-neon.webp'
import holeGlow2 from './assets/venues/glow-golf/hole-2-neon.webp'
import holeGlow3 from './assets/venues/glow-golf/hole-3-neon.webp'
import minigolfParkLogo from './assets/venues/minigolf-park/minigolf-park-logo.svg'
import glowLogo from './assets/venues/glow-golf/glow-minigolf-logo.webp'

export const COURSES = [
  {
    id: 'glow-golf',
    name: 'Glow Golf',
    holes: 3,
    description: 'Glow-in-the-dark indoor minigolf',
    color: '#6a3de8',
    logo: glowLogo,
    holesData: [
      { number: 1, name: 'The Start', distance: 10, par: 3, image: holeGlow1 },
      { number: 2, name: 'The Loop', distance: 10, par: 3, image: holeGlow2 },
      { number: 3, name: 'The Finish', distance: 10, par: 3, image: holeGlow3 },
    ],
  },
  {
    id: 'minigolf-park',
    name: 'Mini Golf in het Bos',
    holes: 3,
    description: 'Met pittige obstakels, water en zandbunkers!',
    color: '#076631',
    logo: minigolfParkLogo,
    holesData: [
      { number: 1, name: 'The Opener', distance: 8.05, par: 2, image: hole1 },
      { number: 2, name: 'Left Turn', distance: 11.25, par: 3, image: hole2 },
      { number: 3, name: 'Right Turn', distance: 13.08, par: 4, image: hole3 },
    ],
  },
]

export const LEGACY_COURSE_IDS = {
  'glowgolf-amsterdam': 'glow-golf',
  'minigolf-amsterdam': 'minigolf-park',
}

export function findCourse(id) {
  return COURSES.find((c) => c.id === id)
}

export function findHole(courseId, number) {
  const course = findCourse(courseId)
  if (!course) return undefined
  return course.holesData.find((h) => h.number === number)
}

export const COURSE_LOGO = minigolfParkLogo
